export default __webpack_public_path__ + "static/media/EM0380.34I-22662_-15276_0.f52ebcdf.jpg";